import {
  WSContainer,
  WSGrid,
  WSScreen
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { FeatureInfo } from "../components/FeatureInfo/FeatureInfo";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { SubscriptionWidget } from "../components/SubscriptionWidget/SubscriptionWidget";

interface OnboardingStep4BookkeepingProps {}
export const OnboardingStep4Bookkeeping: React.FC<OnboardingStep4BookkeepingProps> = () => {
  const history = useHistory();
  const onBack = () => {
    history.push("/member/onboarding/step/3/bookkeeping");
  };

  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 4 | Bookkeeping" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <WSGrid.Container>
          <WSGrid.Item XS={6} M={6}>
            <WSScreen.Mobile>
              <FeatureInfo
                title="Bookkeeping you can bank on."
                featureItems={[
                  "Net paycheck – we build you a paystub",
                  "Expense tracking",
                  "Automated tax deductions",
                  "Tax planning and compliance support",
                  "Automated quarterly filings"
                ]}
                virtualAssistantMessage="Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
              />
            </WSScreen.Mobile>
            <WSScreen.TabletAndDesktop>
              <FeatureInfo
                title="Bookkeeping you can bank on."
                description="Wingspan's bookkeeping tools help you minimize taxes
                and hang onto more of your money."
                featureItems={[
                  "Net paycheck – we build you a paystub",
                  "Expense tracking",
                  "Automated tax deductions",
                  "Tax planning and compliance support",
                  "Automated quarterly filings"
                ]}
                virtualAssistantMessage="Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
              />
            </WSScreen.TabletAndDesktop>
          </WSGrid.Item>
          <WSGrid.Item XS={6} M={6}>
            <SubscriptionWidget />
          </WSGrid.Item>
        </WSGrid.Container>
      </WSContainer>
    </>
  );
};
